module.exports = __webpack_public_path__ + "img/tab3.f2a6667e.png";